<template>
  <el-popover placement="bottom" :width="400" trigger="hover" :disabled="!isDown">
    <div class="hide-tags-container as-full-wdith as-flex main-start cross-start">
      <template v-for="(item,index) in movieTags?movieTags.slice(showTagNum):[]">
        <span ref="tags" :key="'tag_' + index" :class="['tag-item', 'f-1', 'as-nowrap']">{{item}}</span>
      </template>
    </div>
    <div slot="reference" class="container as-flex main-start corss-center" ref="container">
      <div class="content as-flex main-start cross-end" ref="slotContent">
        <template v-for="(item,index) in movieTags">
          <span
            ref="tags"
            :key="'tag_' + index"
            :class="['tag-item', 'f-1', 'as-nowrap',index<showTagNum?'':'is-hidden']"
          >{{item}}</span>
        </template>
      </div>
      <div v-if="isDown" class="go-item go-next as-flex cross-center">
        <i class="icon el-icon-arrow-down"></i>
      </div>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: "clickSlider",
  props: {
    movieTags: {}
  },
  data() {
    return {
      isDown: false,
      fullWidth: undefined,
      slotWidth: undefined,
      showTagNum: 0
    };
  },
  methods: {
    computedWidth() {
      //是否有下拉
      // this.fullWidth = this.$refs.container.getBoundingClientRect().width;
      // this.slotWidth = this.$refs.slotContent.scrollWidth;
    },
    computedTagsNum() {
      //计算宽度
      this.fullWidth = this.$refs.container.getBoundingClientRect().width;
      this.slotWidth = this.$refs.slotContent.scrollWidth;
      //计算显示的tag个数
      let tagArr = this.$refs.tags || [];
      let count = 0;
      let totalWidth = 0;
      for (let i = 0; i < tagArr.length; i++) {
        if (!tagArr[i].offsetWidth) {
          continue;
        }
        let curTagWidth = tagArr[i].getBoundingClientRect().width + 10;
        if (totalWidth + curTagWidth < this.fullWidth - 25) {
          totalWidth += curTagWidth;
          count++;
        } else {
          break;
        }
      }
      if (count < this.movieTags.length) {
        this.isDown = true;
      } else {
        this.isDown = false;
      }
      this.showTagNum = count;
    }
  },
  created() {},
  mounted() {},
  watch: {
    movieTags: function(to, from) {
      this.$nextTick(() => {
        this.computedWidth();
        this.computedTagsNum();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 15px 0 10px;
}
.hide-tags-container {
  flex-wrap: wrap;
  .tag-item {
    color: #fff;
    margin: 5px 10px;
    background-color: #3085e5;
    border-radius: 3px;
    padding: 1px 5px;
  }
}
.go-item {
  width: 15px !important;
  height: 15px !important;
  height: 100%;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: #909399;
  &:hover {
    color: #1da5fa;
  }
}
.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.tag-item {
  flex-shrink: 0;
  color: #fff;
  margin: 0 10px 0 0;
  background-color: #3085e5;
  border-radius: 3px;
  padding: 1px 5px;
  &.is-hidden {
    visibility: hidden;
  }
}
/deep/ .icon {
  height: 15px;
}
</style>
